import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useCssModule, inject, computed } from "vue";
// const props: Props = {
//   title: "",
//   noEqual: false,
// }
export default /*#__PURE__*/_defineComponent({
  __name: 'YQueryItem',
  props: {
    title: {},
    noEqual: {
      type: Boolean
    },
    titleWidth: {}
  },
  setup(__props) {
    const {
      title,
      noEqual = false,
      titleWidth
    } = __props;
    const css = useCssModule("css");
    const size = inject("size");
    const equal = inject("equal");
    const klass = computed(() => {
      return [css.queryitem, css[size], {
        [css.equal]: equal && !noEqual
      }];
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(klass.value)
      }, [_ctx.title || _ctx.$slots.title ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(_unref(css).title),
        style: _normalizeStyle({
          minWidth: `${_ctx.titleWidth || 86}px`
        })
      }, [_createTextVNode(_toDisplayString(_ctx.title) + " ", 1), _renderSlot(_ctx.$slots, "title")], 6)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")], 2);
    };
  }
});